import Vue from 'vue'
import Vuex from 'vuex'
import razorpayxStore from '@/store/modules/razorpayx'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    razorpayxStore
  }
})
